/// <reference no-default-lib="true"/>
/* eslint-disable */
import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useNavigate } from 'react-router-dom';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    background: '#85287e',
    borderRadius: 3,
    marginTop: theme.spacing(2.5),
    color: '#fff',
    boxShadow:
      'rgba(0, 0, 0, 0.15) 0px 8px 20px',
    '& .MuiMenu-list': {
      padding: '8px',
    },
    '& .MuiMenuItem-root': {
      borderRadius: 4,
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.3),
      },
    },
  },
}));

export default function MenuNavBar({ page, definicoesSistema }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const closeTimer = React.useRef(null);
  const open = Boolean(anchorEl);

  const hasSubmenu = page.menuItens?.length > 0;


  const handleOpen = (event) => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    closeTimer.current = setTimeout(() => {
      setAnchorEl(null);
    }, 150); // pequeno delay para evitar flicker
  };


  const cancelClose = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
  };

  return (
    <div
      onMouseEnter={cancelClose}
      onMouseLeave={handleClose}
    >

      <Button
        size="small"
        onMouseEnter={hasSubmenu ? handleOpen : undefined}
        endIcon={
          hasSubmenu
            ? (open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)
            : undefined
        }
        sx={{ my: 2, color: 'white' }}

        onClick={hasSubmenu ? undefined : () => navigate(page.link)}
      >
        {page.page}
      </Button>


      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        MenuListProps={{
          onMouseEnter: cancelClose,
          onMouseLeave: handleClose,
        }}
        onClose={handleClose}
        disableAutoFocusItem

      >
        <div>
          {page.menuItens.map((menuItem, index) => (
            <MenuItem
              disabled={(menuItem?.servico && !definicoesSistema?.servicos.includes(menuItem.servico))}
              key={index}
              onClick={() => {
                navigate(menuItem.link);
                setAnchorEl(null);
              }}
              sx={{ fontSize: '14px' }}
            >
              {menuItem?.page}
            </MenuItem>
          ))}
        </div>
      </StyledMenu>
    </div>
  );
}
